import { render } from "./SummaryDetails.vue?vue&type=template&id=35f7440c&scoped=true"
import script from "./SummaryDetails.vue?vue&type=script&lang=js"
export * from "./SummaryDetails.vue?vue&type=script&lang=js"

import "./SummaryDetails.vue?vue&type=style&index=0&id=35f7440c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f7440c"]])

export default __exports__